import React from 'react';

export const TopBar = () => (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <a className="navbar-brand" href="">
            Tomato Timer
        </a>
    </nav>
)


// WEBPACK FOOTER //
// ./src/components/TopBar.jsx